<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Search from './search/Index.vue';
import BotSources from './BotSources.vue';
import BotSourceChunks from './BotSourceChunks.vue';
import EditBotSourceChunkDialog from './components/EditBotSourceChunkDialog.vue';
import DeleteBotSourceChunkDialog from './components/DeleteBotSourceChunkDialog.vue';

const props = defineProps({
  bot: {
    type: Object,
    default: () => ({}),
  },
});

const store = useStore();
const { t } = useI18n();

const isSearching = ref(false);
const selectedSource = ref({});
const editBotSourceChunkDialog = ref(null);
const deleteBotSourceChunkDialog = ref(null);

const toggleSearching = () => {
  isSearching.value = !isSearching.value;
};

const onSourceSelected = source => {
  selectedSource.value = source;
};

const openEditChunkPopup = chunk => {
  editBotSourceChunkDialog.value?.open(props.bot, chunk);
};

const openDeleteChunkPopup = chunk => {
  deleteBotSourceChunkDialog.value?.open(props.bot, chunk);
};

const toggleChunkStatus = async chunk => {
  try {
    await store.dispatch('wgptBotSourceChunks/update', {
      botId: props.bot.id,
      sourceId: chunk.sourceId,
      id: chunk.id,
      status: chunk.status === 'draft' ? 1 : 0,
    });
    useAlert(
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.EDIT.API.SUCCESS_MESSAGE'
      )
    );
  } catch (error) {
    useAlert(
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.EDIT.API.ERROR_MESSAGE'
      )
    );
  }
};
</script>

<template>
  <section class="flex h-full">
    <Search
      v-if="isSearching"
      :bot="bot"
      @back="toggleSearching"
      @delete-chunk="openDeleteChunkPopup"
      @toggle-chunk-status="toggleChunkStatus"
      @edit-chunk="openEditChunkPopup"
    />

    <template v-else>
      <div
        class="flex flex-col h-full w-full max-w-[400px] ltr:border-r rtl:border-l border-n-weak shrink-0"
      >
        <BotSources
          :bot="bot"
          @source-selected="onSourceSelected"
          @search="toggleSearching"
        />
      </div>
      <div class="flex items-center justify-center w-full h-full">
        <BotSourceChunks
          :bot="bot"
          :source-id="selectedSource.id"
          @delete-chunk="openDeleteChunkPopup"
          @toggle-chunk-status="toggleChunkStatus"
          @edit-chunk="openEditChunkPopup"
        />
      </div>
    </template>

    <EditBotSourceChunkDialog ref="editBotSourceChunkDialog" />
    <DeleteBotSourceChunkDialog ref="deleteBotSourceChunkDialog" />
  </section>
</template>
